import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles(theme => ({
  sectionContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));
